import axios from 'axios';

import calculateStatus from "../hooks/useComputeStatus";

import { TOKEN_EXPIRED, TIMEOUT, INTERNAL_ERROR } from "../hooks/useAPIHelper";

const GET_REACTIVE_JOBS_URL = '/.netlify/functions/xServiceGetServiceCalls';

const GetServiceCallsFunction = async (filter: string,token:string, selectedCustomerId:string) => {

  const fetchData = async(): Promise<any> => {
    try {
      let serviceCallResponse = await axios.post(GET_REACTIVE_JOBS_URL,
        `<Parameters><CustomerCode>${selectedCustomerId}</CustomerCode></Parameters>${filter}`,
        {
          headers: {
            'Content-Type': 'application/xml',
            'X-Pronto-Token': token,
          }
        }
      );
      if (serviceCallResponse.status === 200) {
        const jobs = serviceCallResponse.data.XServiceGetServiceCallsResponse.ServiceCalls;
        if (jobs) {
          let newJoblist = [];
          if (!Array.isArray(jobs.ServiceCall)) {
            if(jobs.ServiceCall.TypeCode == "PM") {
              return newJoblist
            } else {
              newJoblist = calculateStatus([jobs.ServiceCall])
            }
          } else {
            newJoblist = calculateStatus(
              jobs.ServiceCall.filter(job => {
                return !job.TypeCode.toLowerCase().includes('p');
              })
            );
          }
          return newJoblist;
        } else {
          return [];
        }
      }
    } catch (err) {
      if(err.response.status == 401) {
        if(err.response.data == 'TokenExpired') {
          throw(TOKEN_EXPIRED)
        }
      } else if(err.response.status == 504) {
        throw(TIMEOUT)
      } else if(err.response.status == 500) {
        throw(INTERNAL_ERROR);
      }
    }
  };

  return await fetchData();
};

export default GetServiceCallsFunction;
